import React from 'react';
import {Box, Link} from '@mui/material';
import {t} from 'i18next';
import ArrTooltipWrapper from '../../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import './CategorizationHeader.scss';
import {ReactComponent as InfoIcon} from '../../../assets/images/info-icon.svg';
import ArrButton from '../../common/arr-button/ArrButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router';
import {CATEGORISATION_TOOLTIP_URL} from '../../../config/env';

const CategorizationHeader: React.FC = () => {
  const {backSourcePath = '/Production/Home', backSourceLabel = 'Production'} =
    useSelector((state: any) => state.categorization);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleBackNavigation = () => {
    if (backSourcePath) navigate(backSourcePath);
    else navigate(-1);
  };

  const backButtonText = backSourceLabel
    ? t('reports.dataAnalysisReport.conceptExplorer.backButtonToSource', {
        source: backSourceLabel,
      })
    : t('reports.dataAnalysisReport.conceptExplorer.backButton');

  return (
    <Box
      className="view-categorization-title"
      aria-label={t('categorization.title')}
      data-testid="vc-view-categorization-title"
    >
      <Box>
        <span tabIndex={0} data-testid={`categorization-header-title`}>
          {t('categorization.title')}
        </span>{' '}
        <ArrTooltipWrapper
          title={t('categorization.headerTooltip.title')}
          trigger={
            <InfoIcon
              className="info-icon"
              fontSize="medium"
              aria-label="information"
              data-testid="vc-tooltip-info"
              tabIndex={0}
            />
          }
        >
          <div data-testid="vc-tooltip-content">
            <p data-testid={`categorization-header-content-domain-url`}>
              {t('categorization.headerTooltip.content')}
              <Link href={CATEGORISATION_TOOLTIP_URL} target="_blank">
                {t(
                  'reports.dataAnalysisReport.conceptExplorer.tooltip.domainUrl'
                )}
              </Link>
            </p>
            <p data-testid={`categorization-header-content1`}>
              {t('categorization.headerTooltip.content1')}
            </p>
            <p
              dangerouslySetInnerHTML={{
                __html: t('categorization.headerTooltip.content2'),
              }}
              data-testid={`categorization-header-p`}
            />
            <p data-testid={`categorization-header-content3`}>
              {t('categorization.headerTooltip.content3')}
            </p>
            <p data-testid={`categorization-header-content4`}>
              {t('categorization.headerTooltip.content4')}
            </p>
            <ul
              data-testid={`categorization-header-content5-content6-content7`}
            >
              <li data-testid={`categorization-header-content5`}>
                <span data-testid={`categorization-header-content5-text`}>
                  {t('categorization.headerTooltip.content5')}
                </span>
              </li>
              <li data-testid={`categorization-header-content6`}>
                {t('categorization.headerTooltip.content6')}
              </li>
              <li data-testid={`categorization-header-content7`}>
                {t('categorization.headerTooltip.content7')}
              </li>
            </ul>
            <p data-testid={`categorization-header-content8`}>
              {t('categorization.headerTooltip.content8')}
            </p>
          </div>
        </ArrTooltipWrapper>
      </Box>
      {backSourcePath && (
        <Box>
          <ArrButton
            variant="text"
            key="back to source name"
            size="small"
            onClick={handleBackNavigation}
            dataTestId="back-to-source-button"
          >
            <ArrowBackIcon fontSize="small" />
            {backButtonText}
          </ArrButton>
        </Box>
      )}
    </Box>
  );
};

export default React.memo(CategorizationHeader);
